<template>
    <ul class="ivu-dropdown-menu"><slot></slot></ul>
</template>
<script>
    export default {};
</script>



// WEBPACK FOOTER //
// dropdown-menu.vue?3d91e964